<template>
  <v-container class="fill-height text-center">
    <v-row align="center">
      <v-col cols="12">
        <v-btn to="/">
          <v-icon>home</v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <pre>mdd-pagina</pre>
      <pre>{{ doc }}</pre>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "mdd-pagina",
  props: ["doc"]
};
</script>
